export default __webpack_public_path__ + "static/excited-woman-14e40227cf17bb09a640eec39c39b7b4.jpg";